export enum InspectionDecisionsEnum {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
}
